import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetProjectBOUsersRPC } from "./getProjectBoUsersRPC";

export class GetProjectBOUsersRPCClientImpl extends GetProjectBOUsersRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetProjectBOUsersRPC.Request): Promise<LeoRPCResult<GetProjectBOUsersRPC.Response, GetProjectBOUsersRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "project/GetProjectBOUsers",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetProjectBOUsersRPC.ResponseDTO,
      GetProjectBOUsersRPC.Errors.ErrorsDTO,
      GetProjectBOUsersRPC.Response,
      GetProjectBOUsersRPC.Errors.Errors
    >(
      response,
      "project/GetProjectBOUsers",
      GetProjectBOUsersRPC.Response.fromDTO,
      GetProjectBOUsersRPC.Errors.fromDTO
    );
  }
}
